import React from 'react'
import HeaderV2 from './v2'
import { RouteComponentProps, withRouter } from 'react-router'

export interface HeaderProps extends RouteComponentProps<{}> {
  collapsable?: boolean
  transparent?: boolean
  className?: string
  hideSecondaryNav?: boolean
  stickyHeader?: JSX.Element
  stickyHeaderAfterScroll?: boolean
  replaceSearchWithPath?: boolean
}

// Leaving this proxy in place for the inevitable next header test
const Header: React.SFC<HeaderProps> = ({ ...props }) => {
  return <HeaderV2 {...props} />
}

export default withRouter(Header)
